import type { IconComponent } from './icons';
import type { StatusAlias } from './StatusPill';

export type StatCardProps = {
  tone: StatusAlias;
  icon: IconComponent;
  label: string;
  value: string;
  sub?: string;
  trend?: 'up' | 'down';
};

export const StatCard = ({ tone, icon: I, label, value, sub, trend }: StatCardProps) => (
  <div
    className="p-card p-card--interactive"
    style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: 16 }}
  >
    <div className={`p-stat__icon p-stat__icon--${tone}`}>
      <I size={18} />
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <p style={{ fontSize: 12, fontWeight: 500, color: 'var(--p-muted-fg)', margin: 0 }}>{label}</p>
      <p
        className="tabular"
        style={{ fontSize: 26, fontWeight: 700, margin: '2px 0 0', letterSpacing: '-0.02em' }}
      >
        {value}
      </p>
      {sub && (
        <p
          style={{
            fontSize: 12,
            margin: '2px 0 0',
            color:
              trend === 'up'
                ? 'var(--status-success-ink)'
                : trend === 'down'
                  ? 'var(--status-error-ink)'
                  : 'var(--p-muted-fg)',
          }}
        >
          {sub}
        </p>
      )}
    </div>
  </div>
);
